import { createStyles } from '@mantine/core'

export default createStyles((theme, { color }: { color?: string }) => {
  return {
    root: {
      ...(color && {
        backgroundColor: theme.colors?.[color]?.[0],
      }),
      [theme.fn.largerThan('sm')]: {
        borderRadius: 24,
      },
    },
    inner: {},
    header: {},
  }
})
